export default __webpack_public_path__ + "static/media/MVP_En.f34cdeae.jpg";